// extracted by mini-css-extract-plugin
module.exports = {"taglineContainer":"tagline_taglineContainer__kFT6x","title":"tagline_title__VEifU","tagline":"tagline_tagline__QbYKE","taglineButton":"tagline_taglineButton__r_Dhe"};